import React from 'react';
import { CoordinatesAlert } from 'react/components/Maps';
import CrudTab from 'react/containers/pages/CrudTab';
import { fixGridAndFilterBuilder } from 'react/utils/utils';

class TrackEquipmentMapsDisplay extends CrudTab {

  static tabName = 'Greenmile.TrackEquipment.screenName'

  goToRouter = () => {
    const { tab } = this.props;
    const [id, , entityId] = tab.pathname.split('/').slice(2);
    this.router = this.router || new App.Routers.TrackEquipmentMaps();
    this.router.show(id, entityId);
  }

  componentDidMount() {
    this.goToRouter();
  }

  componentDidUpdate(prevProps) {
    const { active, tab } = this.props;
    const isComingFromAnotherTab = active !== prevProps.active;
    const hasChanged = tab.pathname !== prevProps.tab.pathname;
    const { isComingFromEquipmentLink } = Monet.Session.TrackEquipmentMaps;

    if (isComingFromAnotherTab && active) {
      fixGridAndFilterBuilder();
    }

    if (hasChanged || isComingFromEquipmentLink) {
      this.goToRouter();
    }
  }

  render() {
    const { active } = this.props;
    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;

    return (
      <div className={className}>
        <div id="TrackEquipmentMaps">
          <CoordinatesAlert alertKey="trackEquipmentCoords" />
        </div>
      </div>
    );
  }

}

export default TrackEquipmentMapsDisplay;
